// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ny-c";
export var backButton = "_ny-4";
export var backIcon = "_ny-5";
export var chevronShortcut = "_ny-6";
export var container = "_ny-1";
export var editor = "_ny-8";
export var editorWrapper = "_ny-7";
export var prefix = "_ny-2";
export var searchIcon = "_ny-3";
export var suffix = "_ny-9";
export var suffixContent = "_ny-a";
export var suffixText = "_ny-b";
export var wrapper = "_ny-0";